/**
 * Tag names that are managed exclusively by the system.
 * These tags must not be added, removed, or interacted with by users in the UI.
 */

const SYSTEM_TAG_NAMES = [
  'LABEL_REGENERATING',
  'BACKFILLED_SHIP_BY',
  'SHIP_BY_OVERRIDDEN',
  'CENTRAL_FILL_RX',
];

export default SYSTEM_TAG_NAMES;
